// extracted by mini-css-extract-plugin
export default {"SearchResults":"SearchResults_SearchResults__Ro+2S","view-all":"SearchResults_view-all__lAztr"};